import React from 'react';
import { Input } from 'reactstrap';
import { mustBeArray } from '../../utils';
import DragAndDropUpload from './DragAndDropUpload';

const UrgetnRequestUploadsAndNotes = ({
    files,
    notes,
    handleFileChange,
    handleFileDelete,
    handleNoteChange
}) => {
    return(<div className='urgent-request-upload'>
        <DragAndDropUpload handleChange={handleFileChange}/>
        <div className="flex flex-wrap mb-1">
        {mustBeArray(files).map((image, i) => {
          return (
            <div className="mb-1 pl-1 pr-1 mt-2" key={i}>
              <div>
                <img
                  src={image.blobUri || image.fileContents}
                  key={i}
                  width="285px"
                  height="100%"
                  className="mb-q"
                />
              </div>
              <div
                className="mr-q float-left"
                style={{
                  width: "270px",
                  textOverflow: "ellipsis",
                  overflow: "clip",
                }}
              >
                {image.fileName}
              </div>
              {!image.blobUri && (
                <i
                  className="fa fa-times hand float-right pt-q text-danger"
                  aria-hidden="true"
                  onClick={(e) => handleFileDelete({ image, index: i })}
                />
              )}

              <div className="clearfix" />
            </div>
          );
        })}
      </div>
      <div className="mt-1 mb-1">
        <label htmlFor="feedback" className="font-weight-bold mb-h mt-h">
        Additional Information
        </label>
        <Input
          type="textarea"
          rows={5}
          id="feedback"
          value={notes}
          onChange={handleNoteChange}
        />
      </div>
    </div>);
};

export default UrgetnRequestUploadsAndNotes;